export default __webpack_public_path__ + "static/media/feature-mngd-services-1.8382cf71.png";